import React from "react"
import { withTranslation } from "react-i18next"

const Cobranza = props => {
  return <></>
}

export default withTranslation()(Cobranza)
